
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "69ca10eee6e7882e8f03fbc6";
              window.beaePageSetting.pageTitle = "Blog"; 
              window.beaePageSetting.pageType = "blog";

          let js_LIV8DHQ2 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-09zzcbensection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-09zzcben',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-09zzcben');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-09zzcben: ', ex)
      };
    

      try {
        let argid = 'beae-410fxdsiblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-410fxdsi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-410fxdsi');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-410fxdsi: ', ex)
      };
    

      try {
        let argid = 'beae-87pgjudqblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-87pgjudq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-87pgjudq');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-87pgjudq: ', ex)
      };
    

      try {
        let argid = 'beae-vyanpt0dsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vyanpt0d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vyanpt0d');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vyanpt0d: ', ex)
      };
    

      try {
        let argid = 'beae-umwj2qdysection-blog-posts-page',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-umwj2qdy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-umwj2qdy');
        args.el = args.els[0];
        ((a) => { var h;n();function n(){document.querySelectorAll(".beae-blog-paginate--wrp a").forEach(u=>{(!u.hasAttribute("href")||!u.getAttribute("href").trim())&&(u.addEventListener("click",function(f){f.preventDefault()}),u.classList.add("disabled"),u.style.pointerEvents="none",u.style.opacity="0.5")})}const t=window.location.search,o="/blogs/"+((h=a.blog)==null?void 0:h.handle),r=a.el.querySelectorAll(".beae-blog-list button.beae-blog-btn"),l=a.el.querySelectorAll(".beae-blog-list button.beae-blog-tag-btn");r.length>0&&d(r,t),l.length>0&&d(l,t,o),c();const p=a.el.querySelector(".beae-x-blog-posts-page");function d(g,u="",f=""){if(g.length){const b=window.location.pathname;g.forEach(k=>{k.getAttribute("data-url")===b&&k.classList.add("active"),k.addEventListener("click",function(m){var B;g.forEach(w=>{w.classList.remove("active")}),k.classList.add("active");const y=f+((B=k.getAttribute("data-url"))==null?void 0:B.replace(" ","-"));if(!y)return;const S=new URL(window.location.origin+y+u);x(S.href)})})}}function c(){const g=document.querySelectorAll(".beae-blog-paginate .beae-blog-pagination-btn");g.length&&g.forEach(u=>{u.addEventListener("click",function(f){const b=u.getAttribute("data-url");if(!b)return;const k=new URL(window.location.origin+b);x(k.href)})})}let s={};function v(g,u){return new Promise(f=>{const b=a.el.querySelector(u),k=document.createElement("div");k.innerHTML=g;const m=k.querySelector(u);b&&(b.style.height="fit-content",m?b.innerHTML=m.innerHTML:(b.style.height="0px",b.style.overflow="hidden")),f()})}function x(g){if(s={},!p)return;const u=p.getAttribute("section-template-id"),f=new URL(g);let b=f.search?f.search.replace("?",""):"";const k=f.pathname+"?section_id="+u+"&"+b;fetch(k).then(m=>m.text()).then(m=>{s[k]=m,v(m,".beae-x-blog-posts"),v(m,".beae-blog-paginate"),c()}),history.pushState({searchParams:b},"",`${f.pathname}${b&&"?".concat(b)}`)} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-umwj2qdy: ', ex)
      };
    

      try {
        let argid = 'beae-ko8fq7e2block-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ko8fq7e2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ko8fq7e2');
        args.el = args.els[0];
        ((data
) => { data.el.querySelectorAll('.beae-blog-tag-btn').forEach(button => {
    const url = button.getAttribute('data-url');
    if (url === '/tagged/') {
      button.setAttribute('data-url', '/');
    
    }
    if (button.getAttribute('data-url') === '/') {
      button.classList.add('active');
    }
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ko8fq7e2: ', ex)
      };
    

      try {
        let argid = 'beae-bcc7kgifblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bcc7kgif',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bcc7kgif');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bcc7kgif: ', ex)
      };
    

      try {
        let argid = 'beae-118dfhrcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-118dfhrc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-118dfhrc');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-118dfhrc: ', ex)
      };
    

      try {
        let argid = 'beae-tcdnchseblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tcdnchse',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tcdnchse');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tcdnchse: ', ex)
      };
    

      try {
        let argid = 'beae-4s9hb7p1block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4s9hb7p1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4s9hb7p1');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4s9hb7p1: ', ex)
      };
    

      try {
        let argid = 'beae-0hhqtr2lblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0hhqtr2l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0hhqtr2l');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0hhqtr2l: ', ex)
      };
    }; if (window.BEAEBASE) {js_LIV8DHQ2()} else {window.BEAEPAGEJS.push(js_LIV8DHQ2)} })(); 